import { makeBox } from "@seneca/senekit";

import { ReactComponent as wifiBrokenIcon } from "common/assets/images/toasts/wifi-broken.svg";
import { ReactComponent as wifiIcon } from "common/assets/images/toasts/wifi.svg";

import { ToastType } from "../consts";
import { showToast } from "../toast";
import ToastLayout from "../ToastLayout";

const WifiIcon = makeBox(wifiIcon);
const WifiBrokenIcon = makeBox(wifiBrokenIcon);

function NetworkLostToast() {
  return (
    <ToastLayout type={ToastType.warning}>
      {{
        icon: WifiBrokenIcon,
        title: "Aw snap!",
        description: "You're offline. Connect or your progress won't be saved."
      }}
    </ToastLayout>
  );
}

function NetworkReconnectToast() {
  return (
    <ToastLayout type={ToastType.success}>
      {{
        icon: WifiIcon,
        title: "Keep studying!",
        description: "Your connection looks normal"
      }}
    </ToastLayout>
  );
}

function SessionSaveFailedToast() {
  return (
    <ToastLayout type={ToastType.error}>
      {{
        icon: WifiBrokenIcon,
        title: "Oops!",
        description:
          "Your progress failed to save. Check that you're connected to the internet."
      }}
    </ToastLayout>
  );
}

export const showNetworkLostToast = () =>
  showToast(NetworkLostToast, {
    delay: true,
    // Setting toastId means we will not show more than one toast of this type on the screen at once
    toastId: "showNetworkLostToast"
  });

export const showNetworkReconnectToast = () =>
  showToast(NetworkReconnectToast, {
    delay: true,
    toastId: "showNetworkReconnectToast"
  });

export const showSessionSaveFailedToast = () =>
  showToast(SessionSaveFailedToast, {
    toastId: "showSessionSaveFailedToast"
  });
